/* template */
<template minapp="mpx" xlang="wxml"><div class="banner-container"><template v-for="(item, index) in (displayedCoupons)"><component :is="(renderType(item))" :couponData="(item)" @clickExtra="clickExtra"/></template></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3db8f185"}'>
  .banner-container
    display flex
    height 51px
    margin-top 12px
    justify-content space-between
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3db8f185"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex3db8f185%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex3db8f185%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3db8f185"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index3db8f185/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'large-coupon':getComponent(require("./large-coupon.mpx?isComponent&outputPath=components%2Flarge-coupon0ca8b053%2Findex")),'large-package':getComponent(require("./large-package.mpx?isComponent&outputPath=components%2Flarge-package5a31c367%2Findex")),'small-coupon':getComponent(require("./small-coupon.mpx?isComponent&outputPath=components%2Fsmall-coupon4c9eff07%2Findex")),'small-package':getComponent(require("./small-package.mpx?isComponent&outputPath=components%2Fsmall-package19054b33%2Findex")),'new-coustomer-coupon':getComponent(require("./new-coustomer-coupon.mpx?isComponent&outputPath=components%2Fnew-coustomer-coupon69c8a1a6%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
